export default __webpack_public_path__ + "static/preview-cf274f04f2651ae4f0633f974c01ccfd.jpg";